import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import app from './app';
import auth from './auth';
import user from './user';
import candidate from './candidate';
import checkup from './checkup';
import dashboard from './dashboard';
import reports from './reports';
import store from './store';
import scheduleCheckup from './scheduleCheckup';

export const history = createBrowserHistory();

export enum Status {
  pending = 'pending',
  fulfilled = 'fulfilled',
  rejected = 'rejected',
}

const rootReducer = combineReducers({
  router: connectRouter(history),
  app,
  auth,
  user,
  candidate,
  checkup,
  dashboard,
  reports,
  store,
  scheduleCheckup,
});
export default rootReducer;
export type RootState = ReturnType<typeof rootReducer>;
